import api from "./api";

class SettoriManager {

    settori(config?: any) {
        return api.get(`/settori`, config)
    }

    retrieveAll(ids: number[]) {
        return api.get(`/settori/ids`, {params: {ids}}) 
    }

    list = this.settori
}

const settoriManager = new SettoriManager()

export default settoriManager
